// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon May 12 2025
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const HWPExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#3977C9" />
				<path
					d="M19.2051 13.918H26V16.5361H22.9248C23.6189 17.526 24.0273 18.7296 24.0273 20.0283C24.0271 23.4024 21.2792 26.1377 17.8896 26.1377C14.5002 26.1376 11.7522 23.4024 11.752 20.0283C11.752 18.7297 12.1605 17.526 12.8545 16.5361H9.99902V13.918H16.5742V10.8633H19.2051V13.918ZM17.8896 16.5361C15.9528 16.5363 14.3828 18.1002 14.3828 20.0283C14.383 21.9562 15.953 23.5194 17.8896 23.5195C19.8265 23.5195 21.3972 21.9563 21.3975 20.0283C21.3975 18.1001 19.8266 16.5361 17.8896 16.5361Z"
					fill="white"
				/>
			</Svg>
		);
	}
);
HWPExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default HWPExtension;
